var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome da Turma",
      "outlined": "",
      "dense": ""
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.buscarTurmas();
      }
    },
    model: {
      value: _vm.form.filters.nome,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "nome", $$v);
      },
      expression: "form.filters.nome"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Município",
      "item-text": "nome",
      "item-value": "id",
      "outlined": "",
      "return-object": "",
      "dense": "",
      "items": _vm.form.lists.listMunicipiosFilter
    },
    on: {
      "change": _vm.filterEscolasByMunicipios
    },
    model: {
      value: _vm.form.filters.municipio,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "municipio", $$v);
      },
      expression: "form.filters.municipio"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Professor",
      "outlined": "",
      "dense": "",
      "maxlength": "70"
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.buscarTurmas();
      }
    },
    model: {
      value: _vm.form.filters.professor,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "professor", $$v);
      },
      expression: "form.filters.professor"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "only-number",
      rawName: "v-only-number"
    }],
    attrs: {
      "label": "Ano Letivo",
      "outlined": "",
      "dense": "",
      "maxlength": "4",
      "rules": [function (v) {
        return !v || v >= 1900 && v <= new Date().getFullYear() + 1 || 'Ano Letivo inválido.';
      }]
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.buscarTurmas();
      }
    },
    model: {
      value: _vm.form.filters.anoLetivo,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "anoLetivo", $$v);
      },
      expression: "form.filters.anoLetivo"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Ano/Série",
      "item-text": "nome",
      "item-value": "id",
      "outlined": "",
      "dense": "",
      "items": _vm.form.lists.listAnoSeries
    },
    model: {
      value: _vm.form.filters.serieId,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "serieId", $$v);
      },
      expression: "form.filters.serieId"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Escola",
      "item-text": "local",
      "item-value": "id",
      "outlined": "",
      "return-object": "",
      "dense": "",
      "items": _vm.form.lists.listEscolasFilter,
      "loading": _vm.loadingEscolas
    },
    on: {
      "focus": _vm.ensureEscolas,
      "change": _vm.filterMunicipiosByEscola
    },
    model: {
      value: _vm.form.filters.escola,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "escola", $$v);
      },
      expression: "form.filters.escola"
    }
  })], 1), _c('sca-select-ativo', {
    attrs: {
      "cols": 3,
      "config": {
        labelAtivo: 'Ativo',
        labelInativo: 'Inativo',
        label: 'Situação'
      }
    },
    model: {
      value: _vm.form.filters.ativo,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "ativo", $$v);
      },
      expression: "form.filters.ativo"
    }
  })], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sca-tooltip', {
    attrs: {
      "text": 'Buscar',
      "icon": 'mdi-magnify'
    },
    on: {
      "click": function ($event) {
        return _vm.buscarTurmas();
      }
    }
  }), _c('sca-tooltip', {
    attrs: {
      "text": 'Limpar',
      "icon": 'mdi-eraser'
    },
    on: {
      "click": function ($event) {
        return _vm.resetForm();
      }
    }
  }), _c('sca-tooltip', {
    attrs: {
      "text": 'Adicionar',
      "icon": 'mdi-plus'
    },
    on: {
      "click": function ($event) {
        return _vm.openDialogManterTurma();
      }
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "headers": _vm.table.headers,
      "items": _vm.table.itens,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps,
      "show-expand": "",
      "no-data-text": _vm.table.noDataText,
      "expanded": _vm.expanded
    },
    on: {
      "update:expanded": function ($event) {
        _vm.expanded = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "expanded-item",
      fn: function (_ref) {
        var headers = _ref.headers,
          item = _ref.item;
        return [_c('td', {
          staticClass: "permissoes",
          attrs: {
            "colspan": headers.length
          }
        }, [_c('v-chip-group', {
          attrs: {
            "active-class": "primary--text",
            "column": ""
          }
        }, _vm._l(item.professores, function (prof, i) {
          return _c('v-chip', {
            key: i,
            staticClass: "chip-permissao"
          }, [_vm._v(" " + _vm._s(_vm.labelProfessor[i]) + " "), _c('b', [_vm._v(_vm._s(prof))])]);
        }), 1)], 1)];
      }
    }, {
      key: `item.situacao`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('sca-label-ativo', {
          attrs: {
            "ativo": item.ativo,
            "config": {
              labelAtivo: 'Ativo',
              labelInativo: 'Inativo'
            }
          }
        })];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('sca-tooltip', {
          attrs: {
            "text": 'Visualizar',
            "icon": 'mdi-eye-outline',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogVisualizarTurma(item);
            }
          }
        }), _c('sca-tooltip', {
          attrs: {
            "text": 'Editar',
            "icon": 'mdi-pencil',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogManterTurma(item);
            }
          }
        }), _c('sca-tooltip', {
          attrs: {
            "text": `${item.situacao ? 'Inativar' : 'Ativar'}`,
            "icon": `${item.situacao ? 'mdi-toggle-switch-off' : 'mdi-toggle-switch'}`,
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.inativarAtivarTurma(item);
            }
          }
        })];
      }
    }], null, true)
  })], 1), _c('CadastrarEditarTurmaDialog', {
    attrs: {
      "visible": _vm.dialogManterTurma.visible,
      "content": _vm.dialogManterTurma.content,
      "edit": _vm.dialogManterTurma.edit,
      "lists": _vm.form.lists
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogManterTurma.close();
      },
      "onSave": function ($event) {
        return _vm.buscarTurmas();
      }
    }
  }), _vm.dialogVisualizarTurma.visible ? _c('VisualizarTurmaDialog', {
    attrs: {
      "visible": _vm.dialogVisualizarTurma.visible,
      "content": _vm.dialogVisualizarTurma.content,
      "lists": _vm.form.lists
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogVisualizarTurma.close();
      }
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }